// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCimY0qx6PihZCiPFNrKq73mWWyEYihJTo",
  authDomain: "wespendit.firebaseapp.com",
  projectId: "wespendit",
  storageBucket: "wespendit.appspot.com",
  messagingSenderId: "776332784932",
  appId: "1:776332784932:web:8a172cdb75a4b084516fb1",
  measurementId: "G-8NR8C71YFH",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export default app;
